import styles from './ModalHeader.css';

export const RegionalDistrictsModalHeader: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['modal-header']}>{children}</div>;
};
